<template>
    <form id="add_task_form" :action="store_route" method="post" enctype="multipart/form-data" class="mt-5">
        <input type="hidden" name="_token" v-bind:value="csrf">
        <h2 class="h4 font-weight-bold  ">{{ $lang('Osoba tworząca zgłoszenie') }}</h2>
        <div class="row">
            <div class="col-xl-6 form-group">
                <input type="number" hidden name="person_id" v-model="person_id"/>
                <label for="surname">{{ $lang('Nazwisko ') }}
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>
                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <div class="bg-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                    </div>
                    <input id="surname" type="hidden" name="surname" :value="surname">
                    <autocomplete
                        :autoSelect="true"
                        ref="surname"
                        :search="searchPeopleSurname"
                        @submit="handleSurname"
                        :placeholder="$lang('Nazwisko')"
                        :get-result-value="getResult"
                        class="autocomplete-wrapper"
                    ></autocomplete>
                </div>
                <small class="text-red small-70" v-if="!validatePerson() && name!=='' && surname!==''">
                    <a :href="add_person_route+'?tab=people'" style="color: red">
                        {{ $lang(`Brak nazwiska w bazie. Kliknij aby dodać osobę.`) }}
                    </a>
                </small>
            </div>

            <div class="col-xl-6 form-group">
                <label for="name">{{ $lang('Imię ') }}
                    <span class="text-red"> {{ $lang('(wymagane)') }} </span>
                </label>

                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <div class="bg-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                    </div>
                    <input id="name" type="hidden" name="name" :value="name">
                    <autocomplete
                        :autoSelect="true"
                        ref="name"
                        :search="searchPeopleName"
                        @submit="handleName"
                        :placeholder="$lang('Imię')"
                        :get-result-value="getResult"
                        class="autocomplete-wrapper"
                    ></autocomplete>
                </div>


            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 form-group">
                <label for="email">{{ $lang('E-mail ') }}</label>
                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <div class="bg-icon"><i class="fa fa-envelope" aria-hidden="true"></i></div>
                    </div>
                    <input type="text" class="form-control" id="email" name="email"
                           :placeholder="$lang('E-mail')" v-model="email" :disabled="true">
                </div>
            </div>

            <div class="col-xl-6 form-group">
                <label for="phone_number">{{ $lang('Telefon ') }}</label>
                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <div class="bg-icon"><i class="fa fa-phone" aria-hidden="true"></i></div>
                    </div>
                    <input type="text" class="form-control" id="phone_number" name="phone_number" v-model="phone"
                           :disabled="true">
                </div>
            </div>
        </div>

        <h2 class="h4 font-weight-bold  mt-5">{{ $lang('Zgłoszenie dotyczy') }}</h2>
        <div class="form-group">
            <template v-if="is_admin || in_active_consortium">
                <label for="librarySelect">{{ $lang('Biblioteka') }} </label>
                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <div class="bg-icon"><i class="fa fa-university" aria-hidden="true"></i></div>
                    </div>
                    <select id="librarySelect" name="library" class="form-control" v-model="libraryID">
                        <option v-for="library in libraries" :value="library.id">{{ library.name }}</option>
                    </select>
                </div>
            </template>
            <template v-else>
                <label for="libraryInput">{{ $lang('Biblioteka') }} </label>
                <input id="libraryInput" name="library" :value="client.id" hidden>
                <p><strong>{{ client.name }}</strong></p>
            </template>
        </div>
        <div class="form-group">
            <label for="module">{{ $lang('Moduł') }} <span class="text-red"> {{ $lang('(wymagane)') }} </span> </label>
            <div class="input-group mb-2">
                <div class="input-group-prepend">
                    <div class="bg-icon"><i class="fa fa-puzzle-piece" aria-hidden="true"></i></div>
                </div>
                <select id="module" name="module" class="form-control" v-model="moduleID">
                    <option v-for="module in modules" :value="module.id">{{ module.name }}</option>
                </select>
            </div>
        </div>

        <h2 class="h4 font-weight-bold  mt-5">{{ $lang('Typ zgłoszenia') }}</h2>
        <div class="form-group">
            <div>
                <label for="basic_criterion">
                    {{ $lang('Kryterium') }}
                    <span class="text-red">{{ $lang('(wymagane)') }}</span>
                </label>
                <select id="basic_criterion" class="form-control" v-model="basicCriterion">
                    <option v-for="basic_criterion in basic_criteria" :value="basic_criterion.id">
                        {{ basic_criterion.name }}
                    </option>
                </select>
            </div>
            <div class="mt-3" v-if="basicCriterion===-1">
                <label for="error_priority">
                    {{ $lang('Priorytet błędu') }}
                    <span class="text-red">{{ $lang('(wymagane)') }}</span>
                </label>
                <select id="error_priority" class="form-control" v-model="errorPriority">
                    <option v-for="error_priority in error_priorities" :value="error_priority.id">
                        {{ error_priority.name }}
                    </option>
                </select>
            </div>
            <input type="hidden" id="criterion" name="criterion" :value="criterionType"></input>
        </div>


        <div class="form-group" v-if="criterionType!==null">
            <useful-links v-bind:criterion_type="criterionType" :useful_links="useful_links"></useful-links>
        </div>

        <h2 class="h4 font-weight-bold  mt-5">{{ $lang('Zgłoszenie') }}</h2>
        <div class="form-group">
            <label for="subject">{{ $lang('Temat') }} <span
                class="text-red">{{ $lang('(wymagane)') }}</span> </label>
            <div class="input-group mb-2">
                <div class="input-group-prepend">
                    <div class="bg-icon"><i class="fa fa-quote-left" aria-hidden="true"></i></div>
                </div>
                <input type="text" class="form-control" id="subject" name="subject" maxlength="100" v-model="subject">
            </div>
        </div>
        <div class="form-group">
            <label for="description">{{ $lang('Opis') }} <span
                class="text-red">{{ $lang('(wymagane)') }}</span></label>
            <textarea class="form-control" id="description" name="description" rows="5" v-model="description">
            </textarea>
        </div>
        <div class="form-group">
            <label for="subject">{{ $lang('Numer aktualizacji (tj. paczki) na moment rejestracji zgłoszenia') }} <span
                class="text-red">{{ $lang('(wymagane)') }}</span> </label>
            <div class="input-group mb-2">
                <div class="input-group-prepend">
                    <div class="bg-icon"><i class="fa fa-regular fa-hashtag" aria-hidden="true"></i></div>
                </div>
                <input type="text" class="form-control" id="update_number" name="update_number" v-model="updateNumber">
            </div>
        </div>

        <h2 class="h4 font-weight-bold  mt-5">{{ $lang('Załącz pliki') }}</h2>
        <dropzone
            :route_store="attachment_store_route"
            :route_delete="attachment_delete_route"
        ></dropzone>

        <dropzone-submit :delete_route="attachment_delete_route" :csrf="csrf">
            <template v-slot:submit-button="{submit}">
                <button class="pull-right btn btn-primary  mt-3 mb-3" @click="submit()"
                        type="submit" id="submitBtn" :disabled="!valid">
                    {{ $lang('Zapisz') }}
                </button>
            </template>
        </dropzone-submit>
    </form>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import UsefulLinks from "../../useful-task-link/useful-links";
import DropzoneSubmit from "../../dropzone-submit";
import Dropzone from "../../dropzone";

export default {
    name: 'quatra-task-create-form',
    components: {Autocomplete, UsefulLinks, DropzoneSubmit, Dropzone},
    props: {
        csrf: String,
        store_route: String,
        attachment_store_route: String,
        attachment_delete_route: String,
        person_autocomplete_route: String,
        add_person_route: String,
        update_people_route: String,
        libraries: Array,
        modules: Array,
        is_admin: Boolean,
        in_active_consortium: Boolean,
        criteria: Array,
        basic_criteria: Array,
        error_priorities: Array,
        client: Object,
        useful_links: Array,
    },
    data() {
        return {
            name: '',
            surname: '',
            email: '',
            phone: '',
            libraryID: this.client.id,
            moduleID: 0,
            subject: '',
            description: '',
            for_all_info: false,
            person_id: null,
            allPeople: [],
            criterionType: null,
            hasLinks: false,
            serviceType: this.client.service_type,
            updateNumber: '',
            basicCriterion: 0,
            errorPriority: 0,
        }
    },
    computed: {
        valid() {
            return this.validatePerson() && this.validateEmail(this.email) && this.moduleID !== 0
                && this.subject !== '' && this.description !== '' && this.updateNumber !== '' && this.criterionType;
        }
    },
    created() {
        this.updatePeople();
    },
    methods: {
        changeCriterion(chosenCriterion) {
            let chosenCriteriaChecked = document.getElementById('criterion'+chosenCriterion).checked;
            this.uncheckCriteria();
            document.getElementById('criterion'+chosenCriterion).checked = chosenCriteriaChecked;
            if (document.getElementById('criterion'+chosenCriterion).checked) {
                this.criterionType = chosenCriterion;
            } else {
                this.criterionType = null;
            }
            this.setHasLinks(this.criterionType);
        },
        validatePerson() {
            for (const person of this.allPeople) {
                if (person.name.replace(/\s/g, "") === this.name.replace(/\s/g, "")
                    && person.surname.replace(/\s/g, "") === this.surname.replace(/\s/g, "")) {
                    return true;
                }
            }
            return false;
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        searchPeopleName(input) {
            this.name = input
            let results = [];
            if (input.length >= 0) {
                this.allPeople.forEach(function (person) {
                    if (person.name.toLowerCase().includes(input.toLowerCase())) {
                        results.push({name: person.name, surname: person.surname, id: person.id})
                    }
                })
            }
            return [...new Set(results)];
        },
        searchPeopleSurname(input) {
            this.surname = input
            let results = [];
            if (input.length >= 0) {
                this.allPeople.forEach(function (person) {
                    if (person.surname.toLowerCase().includes(input.toLowerCase())) {
                        results.push({name: person.name, surname: person.surname, id: person.id})
                    }
                })
            }
            return [...new Set(results)];
        },
        getResult(result) {
            return result.surname + ' ' + result.name
        },
        handleName(result) {
            if (typeof result !== 'undefined') {
                this.name = result.name;
                this.surname = result.surname;
                this.person_id = result.id;
                result = result.name;
                this.autocomplete();
            }
        },
        handleSurname(result) {
            if (typeof result !== 'undefined') {
                this.surname = result.surname;
                this.name = result.name;
                this.person_id = result.id;
                result = result.surname;
                this.autocomplete();
            }
        },
        autocomplete() {
            let self = this;
            if (this.name !== '' && this.surname !== '') {
                axios.get(this.person_autocomplete_route, {
                    params: {
                        personId: this.person_id,
                    }
                })
                    .then(function (response) {
                        self.email = response.data['email'];
                        self.phone = response.data['phone'];
                        self.name = response.data['name'];
                        self.surname = response.data['surname'];
                        self.person_id = response.data['person_id'];
                        self.$refs.surname.setValue({name: '', surname: self.surname})
                        self.$refs.name.setValue({name: self.name, surname: ''})
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        updatePeople() {
            let self = this;
            axios.get(this.update_people_route, {
                params: {
                    libraryID: self.libraryID
                }
            })
                .then(function (response) {
                    self.allPeople = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        setCriterionType(criterion) {
            if (criterion === 'problem_status') {
                this.criterionType = this.crash_id;
            } else if (criterion === 'failure_status') {
                this.criterionType = this.technical_issue_id;
            }
            if (!document.getElementById('problem_status').checked && !document.getElementById('failure_status').checked) {
                this.criterionType = null;
            }
            this.setHasLinks(this.criterionType);
        },
        setHasLinks(criterion) {
            let criterionLinks = this.useful_links.filter(function(link){
                for (const linkCriterion of link.criteria) {
                    if (linkCriterion.id === criterion) return link;
                }
            });

            this.hasLinks = criterionLinks.length > 0;
        },
        getServiceType() {
            let library = this.libraries.find(lib => lib.id === this.libraryID);
            return library.service_type;
        },
        uncheckCriteria() {
            let criteriaCheckboxes = document.getElementsByName('criterion');
            criteriaCheckboxes.forEach(function (criterionCheckbox) {
                criterionCheckbox.checked = false;
            });
        }
    },
    watch: {
        libraryID() {
            this.updatePeople();
            this.serviceType = this.getServiceType();
        },
        basicCriterion() {
            this.criterionType = this.basicCriterion > 0 ? this.basicCriterion : 0;
        },
        errorPriority() {
            this.criterionType = this.errorPriority > 0 ? this.errorPriority : 0;
        }
    },
}
</script>


